import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiCity\CreateWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/CreateWikiCityController.php
* @route '/api/city'
*/
const CreateWikiCityController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiCityController.url(options),
    method: 'post',
})

CreateWikiCityController.definition = {
    methods: ["post"],
    url: '/api/city',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiCity\CreateWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/CreateWikiCityController.php
* @route '/api/city'
*/
CreateWikiCityController.url = (options?: RouteQueryOptions) => {
    return CreateWikiCityController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiCity\CreateWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/CreateWikiCityController.php
* @route '/api/city'
*/
CreateWikiCityController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiCityController.url(options),
    method: 'post',
})

export default CreateWikiCityController